export default __webpack_public_path__ + "static/media/9.81c6f07c.svg";